import { render, staticRenderFns } from "./videoflow.vue?vue&type=template&id=28082fb8&lang=pug&"
import script from "./videoflow.vue?vue&type=script&lang=js&"
export * from "./videoflow.vue?vue&type=script&lang=js&"
import style0 from "./videoflow.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports